// extracted by mini-css-extract-plugin
export var bot = "chatbot-module--bot--d38c8";
export var botAvatar = "chatbot-module--botAvatar--2b8de";
export var chatHeader = "chatbot-module--chatHeader--08207";
export var chatInput = "chatbot-module--chatInput--d0bf0";
export var chatInputWrapper = "chatbot-module--chatInputWrapper--1abca";
export var chatMessages = "chatbot-module--chatMessages--32235";
export var chatbotBox = "chatbot-module--chatbotBox--7fd4a";
export var chatbotToggle = "chatbot-module--chatbotToggle--9cc5e";
export var chatbotWrapper = "chatbot-module--chatbotWrapper--c01b7";
export var closeButton = "chatbot-module--closeButton--b2307";
export var loadingPadding = "chatbot-module--loadingPadding--94b05";
export var messageBubble = "chatbot-module--messageBubble--aae93";
export var messageText = "chatbot-module--messageText--b75f1";
export var sendButton = "chatbot-module--sendButton--f9055";
export var sendIcon = "chatbot-module--sendIcon--0add9";
export var user = "chatbot-module--user--0590f";
export var wendiWEGnology = "chatbot-module--wendiWEGnology--50893";